import type { ValueOf } from '@weft/utils';

export const NAVIGATION_LABELS = {
  HOME: 'Home',
  CUSTOMERS: 'Customers',
  PLANS: 'Plans & Pricing',
  INVOICES: 'Invoice List',
  DATA_METERING: 'Data Metering',
  INTEGRATIONS: 'Integrations',
  SETTINGS: 'Settings',
  HELP: 'Help',
  BILLING_CYCLE: 'Billing Cycle',
  PRODUCTS: 'Products',
  REPORTS: 'Reports',
};

export type NavigationLabel = ValueOf<typeof NAVIGATION_LABELS>;